import { reflectKeys } from "@utils/key.reflactor.ts";
import { RESOURCE_DOMAIN } from "@/plugins/common/constant/resource.constant";
import { Router } from "vue-router";
import { NotebookAnnotation } from "./notebook-editor-types";
import { AnnotationApiModel } from "../annotation/types";

export const NotebookPageNoteResourceType = {
  NOTE: "NOTE",
  ANNOTATION: "ANNOTATION",
} as const;

export const NOTEBOOK_EDITOR_SAVING_EVENTBUS_EVENT = {
  COMPONENT_BLUR: "COMPONENT_BLUR",
};

export const NOTEBOOK_EDITOR_SAVING_PROMISE_RULE = reflectKeys(["COMPONENT_SAVE"]);

export const THUMBNAIL_RESOURCE_TYPE = reflectKeys(["NOTEBOOK_COVER"]);
export const NOTEBOOK_EDITOR_RIGHT_PANEL = { GENERAL: "general", APPEARANCE: "appearance" };
export const NOTEBOOK_EDITOR_VALIDATION = {
  TITLE_CHARACTER_MAX_LENGTH: 250,
  MAX_PAGES: 50,
  MAX_NOTES: 20,
};

export const NOTEBOOK_MAX_PAGE = 50;
export const NOTEBOOK_MAX_NOTE = 20;
export const NOTEBOOK_MAX_RECENT = 50;
export const NOTEBOOK_LISTING_URL = import.meta.env.VITE_VLE_DOMAIN + "/notebook";
export const NOTEBOOK_SPOTLIGHT_1 = "BLUE";
export const NOTEBOOK_SPOTLIGHT_2 = "ORANGE";
export const NOTEBOOK_SPOTLIGHT_3 = "PINK";
export const NOTEBOOK_CREATE_NEW_NOTEBOOK_ID = -1;
export const NOTEBOOK_CREATE_NEW_NOTEBOOK_UUID = "create-new-notebook-placeholder-uuid";
export const DEFAULT_CREATE_NEW_NOTEBOOK_PLACEHOLDER = "Untitled Notebook";
export const DEFAULT_CREATE_NEW_NOTEBOOK_NAME = "Untitled";

export function isValidUrl(str: string): boolean {
  try {
    new URL(str);
    return true;
  } catch {
    return false;
  }
}

export function openModuleInNewTabFromNotebook(
  annotation: AnnotationApiModel,
  metadata: NotebookAnnotation,
  router: Router,
) {
  if (!metadata || !annotation || !router) return;

  const query = {
    openAnnotation: `${annotation.uuid}_${new Date().getTime()}`,
    user: annotation.ownerId,
  };

  const route =
    metadata.containerResourceDomain === RESOURCE_DOMAIN.MOE
      ? {
          name: "SelfStudyAttemptActivityPage",
          params: {
            lessonUuid: metadata.annotationResourceUuid,
            sectionId: annotation.id,
            pageId: annotation.groupingId,
          },
          query: {
            ...query,
            version: metadata.annotationResourceUuid ? metadata.annotationResourceUuid : undefined,
          },
        }
      : {
          name: metadata.assessment
            ? "AssessmentAttemptActivityPage"
            : "AssignmentAttemptActivityPage",
          params: {
            assignmentUuid: metadata.annotationResourceUuid,
            moduleUuid: metadata.annotationResourceUuid,
            sectionId: annotation.id,
            pageId: annotation.groupingId,
          },
          query,
        };

  const { href } = router.resolve(route);
  window.open(href, "_blank");
}
